import { render, staticRenderFns } from "./KarmaCategoryEdit.vue?vue&type=template&id=ad3e8854&"
import script from "./KarmaCategoryEdit.vue?vue&type=script&lang=js&"
export * from "./KarmaCategoryEdit.vue?vue&type=script&lang=js&"
import style0 from "./KarmaCategoryEdit.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports